var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "promo"
  }, [_c('div', {
    staticClass: "flex gap-5 justify-between items-end mb-6 mdmax:flex-col"
  }, [_c('div', {
    staticClass: "flex w-full gap-5 mdmax:w-full mdmax:flex-col"
  }, [_c('div', {
    staticClass: "w-full max-w-lg mdmax:w-full"
  }, [_c('label', {
    staticClass: "text-base text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Pencarian")]), _c('div', {
    staticClass: "relative"
  }, [_c('TextField', {
    attrs: {
      "type": "text",
      "withIcon": true,
      "placeholder": "Cari promo..."
    },
    on: {
      "enter": _vm.onSearch
    },
    model: {
      value: _vm.search,
      callback: function ($$v) {
        _vm.search = $$v;
      },
      expression: "search"
    }
  }), _c('div', {
    staticClass: "absolute left-3 top-1/2 transform -translate-y-1/2"
  }, [_c('Search')], 1)], 1)])]), _c('div', [_c('button', {
    staticClass: "px-2 py-2 w-32 bg-primary-500 text-white rounded-lg font-medium hover:bg-primary-600 transition-colors",
    on: {
      "click": function ($event) {
        return _vm.$router.push('/promo/create');
      }
    }
  }, [_vm._v(" + Add Promo ")])])]), _c('div', {
    staticClass: "bg-white rounded-lg shadow-sm overflow-hidden"
  }, [_c('div', {
    staticClass: "overflow-x-auto"
  }, [_c('table', {
    staticClass: "w-full text-left border-collapse"
  }, [_vm._m(0), _c('tbody', {
    staticClass: "text-neutral-700 text-sm"
  }, [_vm._l(_vm.items, function (promo) {
    return _c('tr', {
      key: promo.id,
      staticClass: "border-b border-neutral-100 hover:bg-neutral-50 transition-colors"
    }, [_c('td', {
      staticClass: "p-4 font-medium"
    }, [_vm._v(_vm._s(promo.name))]), _c('td', {
      staticClass: "p-4 flex items-center gap-2"
    }, [promo.delivery_service && promo.delivery_service.logo ? _c('img', {
      staticClass: "w-6 h-6 object-contain",
      attrs: {
        "src": promo.delivery_service.logo,
        "alt": "logo"
      }
    }) : _vm._e(), _vm._v(" " + _vm._s(promo.delivery_service ? promo.delivery_service.name : "-") + " ")]), _c('td', {
      staticClass: "p-4"
    }, [_vm._v(" " + _vm._s(_vm.formatDate(promo.start_date)) + " - " + _vm._s(_vm.formatDate(promo.end_date)) + " ")]), _c('td', {
      staticClass: "p-4"
    }, [_vm._v(_vm._s(promo.discount_percentage) + "%")]), _c('td', {
      staticClass: "p-4"
    }, [_vm._v(" " + _vm._s(promo.available_quota) + " / " + _vm._s(promo.quota) + " ")]), _c('td', {
      staticClass: "p-4"
    }, [_c('span', {
      staticClass: "px-2 py-1 rounded text-xs font-medium",
      class: _vm.statusClass(promo.status)
    }, [_vm._v(" " + _vm._s(promo.status) + " ")])]), _c('td', {
      staticClass: "p-4"
    }, [_c('div', {
      staticClass: "flex items-center gap-3"
    }, [_c('button', {
      staticClass: "text-neutral-500 hover:text-primary-500 transition-colors",
      on: {
        "click": function ($event) {
          return _vm.onEdit(promo);
        }
      }
    }, [_c('Pencil', {
      attrs: {
        "width": "18",
        "height": "18"
      }
    })], 1), _c('button', {
      staticClass: "text-neutral-500 hover:text-red-500 transition-colors",
      on: {
        "click": function ($event) {
          return _vm.onDelete(promo);
        }
      }
    }, [_c('Trash', {
      attrs: {
        "width": "18",
        "height": "18"
      }
    })], 1)])])]);
  }), !_vm.items || _vm.items.length === 0 ? _c('tr', [_c('td', {
    staticClass: "p-4 text-center text-neutral-500",
    attrs: {
      "colspan": "7"
    }
  }, [_vm._v(" Data tidak ditemukan! ")])]) : _vm._e()], 2)])])]), !_vm.isMobile && _vm.items.length > 0 ? _c('div', {
    staticClass: "text-neutral-500 font-medium mt-2 text-sm"
  }, [_vm._v(" Menampilkan " + _vm._s((_vm.page - 1) * _vm.limit + 1) + " - " + _vm._s(Math.min(_vm.page * _vm.limit, _vm.meta.total_item)) + " dari " + _vm._s(_vm.meta.total_item) + " ")]) : _vm._e(), _vm.items.length > 0 ? _c('div', {
    staticClass: "mt-8 flex justify-end items-center mb-6"
  }, [_c('pagination', {
    attrs: {
      "currentPage": _vm.page,
      "totalCount": _vm.meta.total_item,
      "pageSize": _vm.limit
    },
    on: {
      "onPageChange": _vm.changePage
    }
  })], 1) : _vm._e(), _c('Modal', {
    attrs: {
      "modalVisible": _vm.deleteModalVisible,
      "width": "400px"
    },
    on: {
      "close": _vm.closeDeleteModal
    }
  }, [_c('div', {
    staticClass: "text-center",
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('h3', {
    staticClass: "text-lg font-bold text-neutral-800 mb-2"
  }, [_vm._v("Hapus Promo")]), _c('p', {
    staticClass: "text-neutral-600 mb-6"
  }, [_vm._v(" Apakah Anda yakin ingin menghapus promo "), _c('strong', [_vm._v(_vm._s(_vm.promoToDelete ? _vm.promoToDelete.name : ""))]), _vm._v("? ")]), _c('div', {
    staticClass: "flex justify-center gap-3"
  }, [_c('button', {
    staticClass: "px-4 py-2 rounded-lg border border-neutral-300 text-neutral-600 hover:bg-neutral-50 font-medium",
    on: {
      "click": _vm.closeDeleteModal
    }
  }, [_vm._v(" Batal ")]), _c('button', {
    staticClass: "px-4 py-2 rounded-lg bg-red-500 text-white hover:bg-red-600 font-medium",
    on: {
      "click": _vm.confirmDelete
    }
  }, [_vm._v(" Hapus ")])])])])], 1);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('thead', [_c('tr', {
    staticClass: "bg-neutral-50 text-neutral-500 text-sm font-semibold border-b border-neutral-200"
  }, [_c('th', {
    staticClass: "p-4"
  }, [_vm._v("Nama Promo")]), _c('th', {
    staticClass: "p-4"
  }, [_vm._v("Layanan Pengiriman")]), _c('th', {
    staticClass: "p-4"
  }, [_vm._v("Periode")]), _c('th', {
    staticClass: "p-4"
  }, [_vm._v("Diskon")]), _c('th', {
    staticClass: "p-4"
  }, [_vm._v("Kuota")]), _c('th', {
    staticClass: "p-4"
  }, [_vm._v("Status")]), _c('th', {
    staticClass: "p-4"
  }, [_vm._v("Action")])])]);

}]

export { render, staticRenderFns }